export function pathRemovingBasePath(path: string, basePath: string): string {
  if (path.startsWith(`${basePath}/`)) {
    return path.slice(basePath.length)
  }
  if (path === basePath) {
    return '/'
  }
  return path
}
